module.exports = __webpack_public_path__ + "img/TRACTOR_LHD_THUMB.e54c6737.jpg";